import { ReadCreditLineStatusResponse } from '../services/avc-credit-line-status.model';

export interface State {
  creditLineStatusLoading: boolean;
  creditLineStatus: ReadCreditLineStatusResponse;
	isError: boolean;
}

export const initialState: State = {
  creditLineStatusLoading: true,
  creditLineStatus: null,
  isError: false
};